export default class ClearNewsInputs {

    constructor() {
        this.settings = {
            $clearForm : $(".js-clear-news-inputs")
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if (this.settings.$clearForm.length) {
            const clearForm = document.querySelector('.js-clear-news-inputs');

            clearForm.addEventListener('click', () => {

                // Reset select inputs
                document.getElementById('category').value = '';

                // Submit the form
                document.getElementById('news').submit();

            }); 
        }
    }
};

new ClearNewsInputs();